// HELPER FUNCTIONS
function gtm_getVariation(number_of_variations) {
  try {
    return "v" + Math.floor(Math.random() * number_of_variations);
  } catch (e) {
    console.error('Error in gtm_getVariation:', e.message);
    return "v0";  // fallback value
  }
}

function gtm_getCookie(name) {
  try {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length == 2) return parts.pop().split(";").shift();
    return null;
  } catch (e) {
    console.error('Error in gtm_getCookie:', e.message);
    return "v0";  // fallback value
  }
}

function gtm_setCookie(name, value, days) {
  try {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    var expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/;domain=.";
  } catch (e) {
    console.error('Error in gtm_setCookie:', e.message);
    // Here, you might want to do something else if setting the cookie fails.
    // Returning "v0" may not make sense in this context, but you could still handle the error in some manner.
  }
}
  
function waitForElement(selector) {
  return new Promise(function (resolve, reject) {
    var element = document.querySelector(selector);
    if (element) {
      resolve(element);
      return;
    }
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        var nodes = Array.from(mutation.addedNodes);
        for (var _i = 0, _nodes = nodes; _i < _nodes.length; _i++) {
          var node = _nodes[_i];
          if (node.matches && node.matches(selector)) {
            observer.disconnect();
            resolve(node);
            return;
          }
        }
        ;
      });
    });
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  });
}

// shim layer with setTimeout fallback
var requestAnimFrame = function () {
  return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function (callback) {
    window.setTimeout(callback, 3000 / 60);
  };
}();
function waitUntil(test) {
  return new Promise(function (resolve) {
    (function poll() {
      if (!test()) return requestAnimFrame(poll, 50);
      return resolve();
    })();
  });
}
;
var observeSelector = function observeSelector(selector, callback) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    timeout: null,
    once: false,
    onTimeout: null,
    document: window.document
  };
  var processed = new Map();
  if (options.timeout || options.onTimeout) {
    console.log('------------------------------------------------------------------------------------------------------------------------------');
    console.log('WARNING: observeSelector options timeout and onTimeout are not yet implemented.');
    console.log('------------------------------------------------------------------------------------------------------------------------------');
  }
  var obs,
    isDone = false;
  var done = function done() {
    if (!obs) console.warn('observeSelector failed to run done()');
    if (obs) obs.disconnect();
    processed = undefined;
    obs = undefined;
    return isDone = true;
  };
  var processElement = function processElement(el) {
    if (processed && !processed.has(el)) {
      processed.set(el, true);
      callback(el);
      if (options.once) {
        done();
        return true;
      }
    }
  };
  var lookForSelector = function lookForSelector() {
    var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    if (el.matches && el.matches(selector)) {
      if (processElement(el)) return true;
    }
    if (el.querySelectorAll) {
      var elements = el.querySelectorAll(selector);
      if (elements.length) {
        for (var i = 0; i < elements.length; i++) {
          var _el = elements[i];
          if (processElement(_el)) return true;
        }
      }
    }
  };
  lookForSelector();

  //We might finish before the mutation observer is necessary:
  if (!isDone) {
    obs = new MutationObserver(function (mutationsList) {
      mutationsList.forEach(function (record) {
        if (record && record.addedNodes && record.addedNodes.length) {
          for (var i = 0; i < record.addedNodes.length; i++) {
            //Need to check from the parent element since sibling selectors can be thrown off if elements show up in non-sequential order
            var el = record.addedNodes[i].parentElement;
            // if (!el) console.warn('observeSelector element has no parent', record.addedNodes[i], record);
            //Note: This appears to also run when elements are removed from the DOM. If the element doesn't have a parent then we don't need to check it.
            if (el && lookForSelector(el)) return true;
          }
        }
      });
    });
    obs.observe(options.document || document, {
      attributes: false,
      childList: true,
      subtree: true
    });
  }
  return function () {
    done();
  };
}; //_observeSelector

const getParam = (name, optSearch) => {
  'use strict';
  optSearch = optSearch || location.search;
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
    results = regex.exec(optSearch);
  return results === null ?
    '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

function gtm_add_cartAttribute(attr_name = null, attr_val = null, multiple_attr_array = []) {
  const body_attributes = multiple_attr_array.length > 0 
    ? multiple_attr_array.join('&') 
    : `attributes[${attr_name}]=${attr_val}`;
  
  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    },
    body: body_attributes,
  }).then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok.');
    }
    return response.json();
  }).then(data => {
    // console.log('Cart updated successfully:', data);
    window.cart_attributes_updated = true;
  }).catch(error => {
    console.error('Failed to update cart:', error);
  });
}

function processDataLayer() {
  if (!window.dataLayer || !Array.isArray(window.dataLayer)) {
    console.warn("dataLayer is not initialized or is not an array.");
    return;
  }

  const exp_cart_data = [];
  for (let dl_item of window.dataLayer) {
    if (dl_item && typeof dl_item === "object" && dl_item.event === "proteus_experiment_pageview") {
      const exp_id = dl_item.proteus_exp_id;
      const exp_var = dl_item.proteus_var_id;

      if (exp_id && exp_var) {
        exp_cart_data.push(`attributes[proteus-experimentation-${exp_id.toLowerCase()}]=[${exp_id}]${exp_var}`);
      } else {
        console.warn("Invalid experiment data:", dl_item);
      }
    }
  }

  if (exp_cart_data.length > 0) {
    // console.log("Adding cart attributes:", exp_cart_data);
    gtm_add_cartAttribute(null, null, exp_cart_data);
  }
}

// Retry logic for dataLayer initialization
let retryCount = 0;
const maxRetries = 10;
const interval = setInterval(() => {
  if (window.dataLayer && Array.isArray(window.dataLayer) && window.dataLayer.length > 0) {
    clearInterval(interval);
    processDataLayer();
  } else if (retryCount >= maxRetries) {
    clearInterval(interval);
    console.warn("dataLayer was not populated in time.");
  }
  retryCount++;
}, 500);

const check_for_returning_user = () => {
  // return session value, if set
  if (window.sessionStorage.getItem("Proteus - is_returning_user")) {
    return window.sessionStorage.getItem("Proteus - is_returning_user") === "true";
  }

  // check for the _ga cookie
  const ga_cookie = document.cookie.split('; ').find(row => row.startsWith('_ga='));
  const is_returning = !!ga_cookie;

  // persist for the session
  window.sessionStorage.setItem("Proteus - is_returning_user", is_returning);

  return is_returning;
}

// init
window.is_returning_user = check_for_returning_user();
